/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-11-26                                                        *
 ******************************************************************************/

export default {
    props:{
        beforeSave:{
            type:Function
        },
        beforeUpdate:{
            type:Function
        },
        dialogConvertToAttributesString:{
            type: Boolean,
            default: true
        },
        dialogConvertToAttributesJson:{
            type: Boolean,
            default: false
        },
        dialogConvertToPricesText:{
            type: Boolean,
            default: false
        }
    },
    provide(){
        return{
            registerDialog: this.registerDialog,
            handleItemSaved: this.handleItemSaved,
            handleItemUpdated: this.handleItemUpdated,
            handleItemDestroyed: this.handleItemDestroyed,
        };
    },
    data(){
        return {
            dialog: null,
        };
    },
    methods:{
        registerDialog(dialog){
            this.dialog= dialog;
        },
        handleItemSaved(){
            this.loadItems();
        },
        handleItemUpdated(){
            this.loadItems();
        },
        handleItemDestroyed(){
            this.loadItems();
        },
    }
}
